<section class="container">
    <header class="header">
        <ol>
            <ng-container
                *ngFor="
                    let step of steps;
                    let i = index;
                    let last = last;
                    let first = first
                ">
                <li
                    [ngClass]="selectedIndex === i ? activeClass : ''"
                    class="relative py-3">
                    @if (!last) {
                        <div
                            class="absolute top-3 ml-1 h-full w-0.5"
                            [ngClass]="{
                                'bg-blue-300': i < selectedIndex,
                                'bg-gray-300': i >= selectedIndex,
                            }"></div>
                    } @else {
                        <div
                            class="absolute top-3 ml-1 h-2 w-0.5"
                            [ngClass]="{
                                'bg-blue-300': i < selectedIndex,
                                'bg-gray-300': i >= selectedIndex,
                            }"></div>
                    }
                    <a
                        (click)="selectedIndex = i"
                        (keyup)="selectedIndex = i - 1"
                        (keydown)="selectedIndex = i + 1"
                        tabindex="i">
                        <div class="relative flex flex-auto">
                            @if (first) {
                                <div
                                    class="flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-full bg-gray-300 duration-300"
                                    [ngClass]="{
                                        'scale-100': i === selectedIndex,
                                    }"
                                    [ngStyle]="{
                                        transform:
                                            'translateY(' +
                                            40 * selectedIndex +
                                            'px)',
                                    }"></div>
                            } @else {
                                <div
                                    class="flex h-2.5 w-2.5 shrink-0 transform items-center justify-center rounded-full transition duration-300 ease-in-out"></div>
                            }

                            <div
                                class="-mt-1 ml-2 flex flex-auto flex-col items-start text-md"
                                [ngClass]="{
                                    'text-white': i === selectedIndex,
                                    'text-gray-400': i !== selectedIndex,
                                }">
                                @if (step.stepLabel) {
                                    <ng-container
                                        [ngTemplateOutlet]="
                                            step.stepLabel.template
                                        ">
                                    </ng-container>
                                } @else {
                                    <ng-template #showLabelText>
                                        {{ step.label }}
                                    </ng-template>
                                }
                            </div>
                        </div>
                    </a>
                </li>
            </ng-container>
        </ol>
    </header>
</section>
